import React, { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function Footer() {
  const [version, setVersion] = useState("");
  const [patchNotes, setPatchNotes] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getVersion();
    getPatchNotes();
  }, [])

  async function getVersion() {
    const response = await fetch("https://uploads.jellyo.net/api/server/version", { credentials: "include"});
    const responseData = await response.json();
  setVersion(responseData.version);
  }

  async function getPatchNotes() {
    const response = await fetch("https://uploads.jellyo.net/api/server/patch-notes", { credentials: "include"});
    const responseData = await response.json();

    if (!responseData.patchNotes) {
      setPatchNotes(null);
      return;
    }

    if (responseData.patchNotes && Object.keys(responseData.patchNotes).length === 0) {
      setPatchNotes(null);
      return;
    }
    
    setPatchNotes(responseData.patchNotes);
  }

  return (
    <>
      <div className="absolute bottom-4 h-5 w-full flex justify-center text-center overflow-hidden">
        {version ? `v${version} ` : ""} 
        <div className={`${!patchNotes ? "hidden" : ""} ms-1`}>
          <span className={!version || !patchNotes ? "hidden" : ""}>•</span>
          <span onClick={() => setOpen(!open)} className="ms-1 hover:underline cursor-pointer">Patch notes</span>
        </div> 
      </div>
      
      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => setOpen(!open)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-[40rem] transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="w-full text-2xl py-4 px-6 font-semibold leading-6 text-gray-900 flex justify-between items-center" 
                  >
                    <span>Patch Notes</span>
                    <i onClick={() => setOpen(!open)} className='bx bx-x cursor-pointer'></i>
                  </Dialog.Title>
                    <hr />
                  <div className='flex flex-col text-lg pt-4 px-6 font-light h-min sm:max-h-[20rem] md:max-h-[30rem] overflow-auto'>
                    {patchNotes && Object.keys(patchNotes).map(versionNumber => (
                      <div key={versionNumber} className="mb-5">
                        <h3 className="mb-1 text-black font-medium">{versionNumber}</h3>
                        <ul className="list-inside">
                          {patchNotes[versionNumber].map((note, index) => (
                          <li key={index} className="px-2 list-disc text-sm">{note}</li>
                        ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
